export default {
    methods: {
        formRequiredRules: function (_msg: String) {
            return [
                (v: string) => !!v || _msg,
            ]
        },
    }
}
